import { Typography } from '@breetometer/components';
import { useModalApi } from 'BreetHooks';
import { useCallback } from 'react';

import DialogTodoListItem from './DialogTodoListItem';

const DialogTodoList = () => {
	const { closeModalDirect } = useModalApi();

	const handleItemBtnClick = useCallback(
		() => () => {
			closeModalDirect('todoList');
		},
		[closeModalDirect]
	);

	return (
		<div className='todo-list-container'>
			<Typography as='h4'>Just a few steps before you're Breet-ready</Typography>

			<div className='todo-list'>
				<DialogTodoListItem
					header='Complete KYB'
					subHeader='Verify your business details to unlock full platform access.'
					status='get-started'
					onClick={handleItemBtnClick()}
				/>

				<DialogTodoListItem
					header='Initiate Sandbox'
					subHeader='Set up your test environment to start building and experimenting.'
					status='pending'
					onClick={handleItemBtnClick()}
				/>

				<DialogTodoListItem
					header='First Production API Key'
					subHeader='Generate your live API key to enable real transactions.'
					status='pending'
					onClick={handleItemBtnClick()}
				/>

				<DialogTodoListItem
					header='Production Webhook URL'
					subHeader='Configure your webhook to receive real-time transaction updates.'
					status='pending'
					onClick={handleItemBtnClick()}
				/>

				<DialogTodoListItem
					header='Make First Transaction'
					subHeader='Make your first live transaction to get started and enjoy full benefits.'
					status='pending'
					onClick={handleItemBtnClick()}
				/>

				<DialogTodoListItem
					header='MFA Authentication'
					subHeader='For multi-layer security, enable third-party authenticator app.'
					status='pending'
					isLast
					onClick={handleItemBtnClick()}
				/>
			</div>
		</div>
	);
};

export default DialogTodoList;
